import { useEffect } from 'react';
import Raven from 'raven-js';

// @ts-expect-error Untyped dependency
import { setupCes } from 'wootric-nps/ces/ces-setup';
// @ts-expect-error Untyped dependency
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import { useExperiments } from '../features/experiments/experimentsQueries';
const SurveyKey = {
  CES: 'ACADEMY',
  CSAT: 'ECOSYSTEM_ACADEMY'
};
const useWootricSurvey = (surveyType, skip) => {
  var _experiments$prol;
  const {
    experiments,
    experimentsLoading
  } = useExperiments();
  const isInCsatControlGroup = (experiments === null || experiments === void 0 || (_experiments$prol = experiments['prol-0007']) === null || _experiments$prol === void 0 ? void 0 : _experiments$prol.parameters.group) === 'control';
  useEffect(() => {
    try {
      if (skip) return;
      if (surveyType === 'CSAT' && !experimentsLoading && isInCsatControlGroup) {
        setupCsat(SurveyKey[surveyType]);
        return;
      }
      if (surveyType === 'CES') {
        setupCes(SurveyKey[surveyType]);
        return;
      }
      return;
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          from: 'triggerWootricSurvey',
          surveyType,
          surveyKey: SurveyKey[surveyType]
        }
      });
    }
  }, [skip, surveyType, experimentsLoading, isInCsatControlGroup]);
};
export default useWootricSurvey;